module.exports = __webpack_public_path__ + "img/Varenstraat-na2.4c3db142.jpg";